import { useEffect, useState } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function CountrySelector({ value, onChange }) {
  const { i18n, t } = useTranslation();
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    fetch("/locales/countries.json")
      .then((res) => res.json())
      .then((data) => setCountries(data))
      .catch((err) => console.error("Error loading countries:", err));
  }, []);

  const getLabel = (country) =>
    i18n.language === "es" ? country.label_es : country.label_en;

  return (
    <Autocomplete
      options={countries}
      getOptionLabel={(option) => getLabel(option)}
      value={countries.find((c) => c.alpha2 === value) || null}
      onChange={(e, newValue) => onChange(newValue?.alpha2 || "")}
      renderInput={(params) => (
        <TextField {...params} label={t("Country")} variant="standard" />
      )}
    />
  );
}
